export default {

    transactionUrl(provider, transactionId) {
        if (provider === 'braintree') {
            return "https://www.braintreegateway.com/merchants/m6f3n3v683gc947s/transactions/" + transactionId;
        }
    },

    clientUrl(provider, clientId) {
        if (provider === 'braintree') {
            return "https://www.braintreegateway.com/merchants/m6f3n3v683gc947s/customers/" + clientId;
        }
    },

    paymentMethod(provider, paymentMethodId) {
        if (provider === 'braintree') {
            return "https://www.braintreegateway.com/merchants/m6f3n3v683gc947s/payment_methods/any/" + paymentMethodId;
        }
    },
}


// WEBPACK FOOTER //
// ./src/lib/helpers/gatewayUrlHelper.js